<template>
  <span class="tooltip"><slot></slot></span>
</template>

<script>
export default {
  name: 'tooltip',
  methods: {
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.tooltip {
  position: absolute;
  background-color: #F76800;
  border-radius: 20px;
  padding: 5px 10px;
  color: #fff;
  top: -11px;
  right: 0;
  transform: translateX(30%);
  font-size: 14px;
  line-height: 14px;
  height: 14px;
  white-space: nowrap;
  &:before{
    position: absolute;
    content: "";
    width: 0;
    height: 0;
    border: transparent 10px solid;
    border-left-color: #F76800;
    bottom: -8px;
    left: 10px;
    z-index: -1;
  }
}
</style>
